import * as RoleTypes from "@wesstron/utils/Api/constants/roleTypes";
import * as UserTypes from "@wesstron/utils/Api/constants/userTypes";
import {get, isEmpty} from "lodash";
import moment from "moment";
import {createSelector} from "reselect";
import {farmExpiration} from "../constans/farmExpiration";
import {checkIfUserIsService} from "../utils/NewRolesUtils";
import {getEmployees, getUser} from "./userSelector";

export const getFarmsFromUser = (state) => state.user.user.FarmData;

const getSelectedUser = (state, {selectedUser}) => selectedUser;

export const getFarm = (state, FarmID) =>
    state.farms.farms.find((item) => item.FarmID === FarmID);

export const getFarmID = (state) => state.location.farm;

const getFarmObjectFromState = (state) => getFarm(state, state.location.farm);

const getFarmIDFromSearch = (_, props) => {
    const search = new URLSearchParams(props?.location?.search || "");
    return search.get("FarmID");
};

export const getFarms = (state) => state.farms.farms;

export const getFarmObject = createSelector(
    getFarmObjectFromState,
    getFarms,
    getFarmIDFromSearch,
    (farm, farms, FarmID) => {
        if (farm) return farm;
        return farms.find((item) => item.FarmID === FarmID);
    }
);

export const getTestSwitchStatus = (state) => state.farms.testSwitch;

export const getSubscriptionFilter = (state) => state.farms.subscriptionFilter;

export const getFarmIfUserHasUserManagementRole = createSelector(
    [getUser, getFarmsFromUser],
    (user, farms) => {
        if (checkIfUserIsService()) {
            return farms.filter((f) => f.ClientID === user.ClientID);
        } else {
            const localRights = get(
                get(user, "Roles", []).find(
                    (role) => role.Role === RoleTypes.USER_MANAGE
                ),
                "LocalRights",
                []
            );
            if (!isEmpty(localRights)) {
                return farms.filter((f) =>
                    localRights.find(
                        (lr) =>
                            lr.FarmID === f.FarmID &&
                            lr.ClientID === user.ClientID
                    )
                );
            }
            return [];
        }
    }
);

export const getFarmsForChoosenUser = createSelector(
    [getFarmsFromUser, getSelectedUser],
    (farms, selectedUser = {}) => {
        // general read wszyscy musza miec ktorzy maja dostep na ferme
        const generalRead = get(selectedUser, "roles", []).find(
            (role) => role.Role === RoleTypes.GENERAL_READ
        );
        if (!isEmpty(generalRead)) {
            return farms.filter((f) =>
                get(generalRead, "LocalRights", []).find(
                    (lr) => lr.FarmID === f.FarmID
                )
            );
        }
        return [];
    }
);

export const getCurrentFarm = createSelector([getFarmObject], (farmObject) => {
    return farmObject;
});

export const getFarmsForChooser = createSelector(
    getFarms,
    getTestSwitchStatus,
    getSubscriptionFilter,
    (farms, testSwitch, subscriptionFilter) => {
        const markers = {};
        const bounds = [];
        const filteredFarms = checkIfUserIsService()
            ? farms.filter((item) =>
                  testSwitch
                      ? item.TestFarm === true
                      : testSwitch === false
                        ? !item.TestFarm
                        : true
              )
            : farms;
        for (const farm of filteredFarms) {
            let coords = [53.228928, 18.095559];
            try {
                if (Array.isArray(farm.FarmCord)) {
                    coords = farm.FarmCord;
                } else {
                    coords = farm.FarmCord.split(",").map(
                        (coord) => +coord.trim()
                    );
                    if (
                        coords.length !== 2 ||
                        isNaN(coords[0]) ||
                        isNaN(coords[1])
                    ) {
                        coords = [53.228928, 18.095559];
                    }
                }
            } catch (e) {
                console.error(e);
                coords = [53.228928, 18.095559];
            }
            const coordsString = coords.join("");
            bounds.push(coords);
            if (!markers[coordsString]) {
                const aliases = new Map();
                aliases.set(farm.ClientID, farm.Alias);
                markers[coordsString] = {coords, farms: [], aliases: aliases};
            } else {
                // moze byc sytuacja gdzie sa fermy pod tymi samymi lokalizacjami - czytaj ktos skopiowal obiekt
                markers[coordsString].aliases.set(farm.ClientID, farm.Alias);
            }
            const timeToExpiring = moment
                .utc(farm.LicenseExpirationDate)
                .endOf("day")
                .diff(moment.utc().endOf("day"), "days");
            markers[coordsString].farms.push({
                FarmID: farm.FarmID,
                name: farm.FarmName,
                ClientID: farm.ClientID,
                licenseExpirationDate: farm.LicenseExpirationDate,
                expiring:
                    timeToExpiring < 0
                        ? "expired"
                        : timeToExpiring < farmExpiration.TWO_WEEKS
                          ? "weeks"
                          : timeToExpiring < farmExpiration.MONTH
                            ? "month"
                            : "no",
                remoteServicing: farm.RemoteServicing,
                isTestFarm: farm.TestFarm || false,
            });
        }
        let farmsToFilter = Object.values(markers);
        if (!subscriptionFilter.active) {
            farmsToFilter = farmsToFilter.filter((item) => {
                item.farms = item.farms.filter(
                    (farm) => farm.expiring !== "no"
                );
                return item.farms.length > 0;
            });
        }
        if (!subscriptionFilter.month) {
            farmsToFilter = farmsToFilter.filter((item) => {
                item.farms = item.farms.filter(
                    (farm) => farm.expiring !== "month"
                );
                return item.farms.length > 0;
            });
        }
        if (!subscriptionFilter.week) {
            farmsToFilter = farmsToFilter.filter((item) => {
                item.farms = item.farms.filter(
                    (farm) => farm.expiring !== "weeks"
                );
                return item.farms.length > 0;
            });
        }
        if (!subscriptionFilter.inactive) {
            farmsToFilter = farmsToFilter.filter((item) => {
                item.farms = item.farms.filter(
                    (farm) => farm.expiring !== "expired"
                );
                return item.farms.length > 0;
            });
        }
        return {
            farms: farmsToFilter,
            bounds: bounds.length > 0 ? bounds : null,
        };
    }
);

export const getFarmsForSearch = createSelector(
    getFarms,
    getTestSwitchStatus,
    (farms, testSwitch) => {
        let filteredFarms = checkIfUserIsService()
            ? farms.filter((item) =>
                  testSwitch
                      ? item.TestFarm === true
                      : testSwitch === false
                        ? !item.TestFarm
                        : true
              )
            : farms;
        return filteredFarms.map((farm) => ({
            name: farm.FarmName,
            FarmID: farm.FarmID,
            address: farm.Adr,
            alias: farm.Alias,
            ClientID: farm.ClientID,
            farm,
        }));
    }
);

export const getFarmsOptionsForClientID = createSelector(
    getFarms,
    getUser,
    (farms, user) => {
        const isService = checkIfUserIsService();
        return farms
            .filter((farm) => farm.ClientID === user.ClientID)
            .map((farm) => ({
                name: `${farm.FarmName} ${isService ? `(${farm.FarmID})` : ""}`,
                value: farm.FarmID,
                FarmName: farm.FarmName,
            }));
    }
);

export const isTOPIGSFarm = createSelector(
    getFarmObject,
    (farm) => !!farm.TOPIGSBusinessNumber
);

export const getOfflineFarm = createSelector(getFarms, (farms) => farms[0]);

export const getTOPIGSBusinessNumber = createSelector(
    getFarmObject,
    (farm) => farm.TOPIGSBusinessNumber || null
);

export const getFarmsForClients = createSelector(
    getFarms,
    getUser,
    (farms, user) => {
        return farms.filter((farm) => farm.ClientID === user.ClientID);
    }
);

const UserTypeLicenseKeys = {
    [UserTypes.OWNER]: "admin",
    [UserTypes.MANAGER]: "manager",
    [UserTypes.USER]: "operator",
    [UserTypes.TV]: "tv",
    [UserTypes.SUPPORT]: "support",
};

/**
 * Zwraca ilosc wolnych licencji uzytkownikow klienta dla kazdego limitowanego typu uzytkownika.
 * Licencje sa wspolne dla wszystkich ferm klienta, wiec bierzemy je z pierwszej fermy.
 * Typy bez licencji nie sa zwracane, brak sekcji users w licencji daje 0 wolnych miejsc.
 * @returns {Object<string, number>} klucz - typ uzytkownika, wartosc - ilosc wolnych licencji
 */
export const getUsersLicenseLeft = createSelector(
    getFarmsForClients,
    getEmployees,
    (farms, employees) => {
        const users = get(farms, [0, "license", "users"], {});
        const result = {};
        for (const [userType, licenseKey] of Object.entries(
            UserTypeLicenseKeys
        )) {
            const limit = users[licenseKey];
            const used = employees.filter(
                (e) => e.enable && e.userType === userType
            ).length;
            result[userType] =
                typeof limit === "number" ? Math.max(limit - used, 0) : 0;
        }
        return result;
    }
);

export const getLicenses = createSelector(getFarmObject, (farm) => {
    console.log("GET LICENSE CALC");
    return farm?.license || {};
});

export const hasAnyBreedingLicense = createSelector(getLicenses, (licenses) => {
    try {
        const breeding = licenses.breeding;
        return breeding.sow || breeding.porker;
    } catch (e) {
        return false;
    }
});

export const hasMapLicense = createSelector(getLicenses, (licenses) => {
    try {
        return licenses.utilities.solidmap;
    } catch (e) {
        return false;
    }
});

export const hasSowLicense = createSelector(getLicenses, (licenses) => {
    try {
        const breeding = licenses.breeding;
        return breeding.sow;
    } catch (e) {
        return false;
    }
});

export const hasPorkersLicense = createSelector(getLicenses, (licenses) => {
    try {
        const breeding = licenses.breeding;
        return breeding.porker;
    } catch (e) {
        return false;
    }
});

function hasDevicesLicense(row) {
    return row.active && row.amount > 0;
}

export const getDevicesLicense = createSelector(getLicenses, (licenses) => {
    try {
        const devices = licenses.devices;
        const result = {};
        for (let device in devices) {
            result[device] = hasDevicesLicense(devices[device]);
        }
        return result;
    } catch (e) {
        return {};
    }
});

export const hasFilesLicense = createSelector(getLicenses, (licenses) => {
    try {
        return licenses.utilities.files;
    } catch (e) {
        return false;
    }
});

export const hasAnalysisLicense = createSelector(getLicenses, (licenses) => {
    try {
        return licenses.utilities.analysis;
    } catch (e) {
        return false;
    }
});

export const hasAILicense = createSelector(getLicenses, (licenses) => {
    try {
        return licenses.utilities.ai;
    } catch (e) {
        return false;
    }
});

export const getBreedingLicense = createSelector(getLicenses, (licenses) => {
    try {
        return licenses.breeding;
    } catch (e) {
        return {};
    }
});
